import { Check } from "lucide-react";

const VisualRegionSelector = ({ options, selectedRegions, onToggle }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
    {options.map((option) => {
      const isSelected = selectedRegions?.includes(option.value);
      return (
        <div
          key={option.value}
          onClick={() => onToggle(option.value)}
          className={`relative group cursor-pointer overflow-hidden rounded-2xl transition-all duration-300 ${
            option.value === "anywhere" ? "col-span-2 md:col-span-1" : ""
          } ${isSelected ? "ring-4 ring-primary ring-offset-2" : "hover:scale-[1.02]"}`}
          data-testid={`option-${option.value}`}
        >
          <div className="aspect-[4/3] relative">
            <img
              src={option.image}
              alt={option.label}
              className={`w-full h-full object-cover transition-all duration-500 ${
                isSelected ? "scale-105" : "group-hover:scale-110"
              }`}
            />
            <div
              className={`absolute inset-0 transition-all duration-300 ${
                isSelected
                  ? "bg-gradient-to-t from-primary/90 via-primary/50 to-primary/20"
                  : "bg-gradient-to-t from-black/80 via-black/40 to-transparent group-hover:from-black/70"
              }`}
            />

            {isSelected && (
              <div className="absolute top-3 right-3 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-lg animate-fade-in">
                <Check className="h-5 w-5 text-primary" />
              </div>
            )}

            <div className="absolute bottom-0 left-0 right-0 p-4">
              <h3 className="text-xl font-bold font-['Manrope'] mb-1 text-white">
                {option.label}
              </h3>
              <p className={`text-sm ${isSelected ? "text-white/90" : "text-white/70"}`}>
                {option.subtitle}
              </p>
            </div>
          </div>
        </div>
      );
    })}
  </div>
);

export default VisualRegionSelector;